<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">{{ $t("industrial.title") }}</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">
      <div class="mstation-introduce-content">
        <div class="mstation-introduce-content-info">
          <div
            class="product-markdown-content"
            v-html="markdownHtml"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import industrialMd from '!!../../../loaders/md-loader.js!@/common/lang/zh/industrial.md'
import industrialMdEn from '!!../../../loaders/md-loader.js!@/common/lang/en/industrial.md'
import { parseMarkdown } from '@/utils/simpleMarkdown'
import industrialPlanImg from '@/assets/solution/industrial_plan.png'
import industrialCaseImg from '@/assets/solution/industrial_case.png'
import cooperate15 from '@/assets/home/cooperate_15.png'
import cooperate16 from '@/assets/home/cooperate_16.png'
import cooperate17 from '@/assets/home/cooperate_17.png'
import cooperate18 from '@/assets/home/cooperate_18.png'
import cooperate19 from '@/assets/home/cooperate_19.png'
import cooperate20 from '@/assets/home/cooperate_20.png'
import cooperate21 from '@/assets/home/cooperate_21.png'
import cooperate22 from '@/assets/home/cooperate_22.png'
import cooperate23 from '@/assets/home/cooperate_23.png'
import cooperate24 from '@/assets/home/cooperate_24.png'
import cooperate25 from '@/assets/home/cooperate_25.png'
import cooperate26 from '@/assets/home/cooperate_26.png'
import cooperate27 from '@/assets/home/cooperate_27.png'
import cooperate28 from '@/assets/home/cooperate_28.svg'
import cooperate29 from '@/assets/home/cooperate_29.png'
import cooperate35 from '@/assets/home/cooperate_35.png'
import cooperate37 from '@/assets/home/cooperate_37.png'
import cooperate38 from '@/assets/home/cooperate_38.png'
import cooperate39 from '@/assets/home/cooperate_39.png'

const industrialImages = {
  'industrial_plan.png': industrialPlanImg,
  'industrial_case.png': industrialCaseImg,
  'cooperate_15.png': cooperate15,
  'cooperate_16.png': cooperate16,
  'cooperate_17.png': cooperate17,
  'cooperate_18.png': cooperate18,
  'cooperate_19.png': cooperate19,
  'cooperate_20.png': cooperate20,
  'cooperate_21.png': cooperate21,
  'cooperate_22.png': cooperate22,
  'cooperate_23.png': cooperate23,
  'cooperate_24.png': cooperate24,
  'cooperate_25.png': cooperate25,
  'cooperate_26.png': cooperate26,
  'cooperate_27.png': cooperate27,
  'cooperate_28.svg': cooperate28,
  'cooperate_29.png': cooperate29,
  'cooperate_35.png': cooperate35,
  'cooperate_37.png': cooperate37,
  'cooperate_38.png': cooperate38,
  'cooperate_39.png': cooperate39,
}

export default {
  name: 'Industrial',
  computed: {
    markdownHtml() {
      const md = this.$i18n.locale === 'en' ? industrialMdEn : industrialMd
      return parseMarkdown(md, { images: industrialImages })
    }
  }
}
</script>

<style scoped>
.mstation-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.mstation-introduce-background {
  margin-top: 70px;
}
.mstation-introduce-banner {
  overflow: hidden;
}
.mstation-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.mstation-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.mstation-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.mstation-introduce-content-info {
  margin-top: 40px;
}
.product-markdown-content {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.product-markdown-content >>> h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 24px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 36px;
}
.product-markdown-content >>> h3 {
  margin-top: 20px;
  margin-bottom: 16px;
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
  text-align: center;
}
.product-markdown-content >>> h4 {
  margin-top: 24px;
  margin-bottom: 12px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(73, 145, 201, 1);
  line-height: 28px;
}
.product-markdown-content >>> p {
  margin-bottom: 16px;
}
.product-markdown-content >>> a {
  color: rgba(73, 145, 201, 1);
  text-decoration: none;
  cursor: pointer;
}
.product-markdown-content >>> a:hover {
  text-decoration: underline;
}
.product-markdown-content >>> .md-image-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
}
.product-markdown-content >>> .md-image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 24px auto;
}
.product-markdown-content >>> .md-image-row-1 {
  flex-direction: column;
}
.product-markdown-content >>> .md-image-row-1 .md-image {
  width: 100%;
  margin: 0;
}
.product-markdown-content >>> .md-image[alt="Industrial Case"] {
  width: 70%;
}
.product-markdown-content >>> .md-image-row-3,
.product-markdown-content >>> .md-image-row-4 {
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  margin: 28px 0;
}
.product-markdown-content >>> .md-image-row-3 .md-image,
.product-markdown-content >>> .md-image-row-4 .md-image {
  flex: 0 0 calc((100% - 72px) / 4);
  min-width: 0;
  max-width: calc((100% - 72px) / 4);
  max-height: 70px;
  width: auto;
  margin: 0;
  object-fit: contain;
}
.product-markdown-content >>> ol {
  padding-left: 20px;
  margin-bottom: 16px;
}
.product-markdown-content >>> ul.md-ul-list {
  list-style-type: disc;
  list-style-position: outside;
  padding-left: 1.4em;
  margin: 16px 0;
}
.product-markdown-content >>> ul.md-ul-list > li {
  margin-bottom: 8px;
}
.product-markdown-content >>> li {
  margin-bottom: 8px;
}
@media screen and (max-width: 768px) {
  .product-markdown-content >>> .md-image-row-3,
  .product-markdown-content >>> .md-image-row-4 {
    flex-wrap: wrap;
  }
  .product-markdown-content >>> .md-image-row-3 .md-image,
  .product-markdown-content >>> .md-image-row-4 .md-image {
    flex: 0 0 calc(50% - 8px);
    max-width: calc(50% - 8px);
  }
}
@media screen and (max-width: 482px) {
  .mstation-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .mstation-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .mstation-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}
</style>
